import _objectDestructuringEmpty from '@babel/runtime-corejs3/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import styles from '../9837bffb195015a4513e93472fb398acea449d84d98f6268afd87828b663e6c1.cfe-internal.js';
import '../../Input/8b306eed80472bc167488d029758903f189ea21b58685c7d85ad4a1de9637088.cfe-internal.js';
import '../../../icons/index.es.js';
import '../../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import SearchIcon from '../../../icons/components/fd44f420e4f0cf097c788b0db805e5b1767bfe0b6caaa7e8803b476a89e57dbc.cfe-internal.js';
import Input from '../../Input/0313aac0a73c29ca9b860be5ca5b212107cd810318bb0b89176cc766dbf84b47.cfe-internal.js';

var MenuSearchBox = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var searchText = translate('searchText');
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.searchBox
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    className: styles.searchBoxIcon,
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement(Input, _extends({
    ref: ref,
    role: "searchbox",
    "aria-label": searchText,
    placeholder: searchText,
    className: styles.searchBoxInput,
    full: true
  }, rest)));
});

export { MenuSearchBox as default };
